export const businessesReducer = (state = {loading: true, resultbusiness: null, businesses: null, business: null, businessesActives: [], total: 0 } , action) => {
    switch (action.type) {
        case 'PROVIDER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                businesses: action.payload.businesses,
                total: action.payload.total
            }
        case 'PROVIDER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                business: action.payload
            }
        case 'PROVIDER_GET_ID_ERROR':
            return {
                ...state,
                loading: false,
                resultbusiness: action.payload.message
            }
        case 'PROVIDER_GETACTIVE_SUCCESS':
            return {
                ...state,
                loading:false,
                businessesActives: [...state.businessesActives, action.payload.businesses],
                resultbusiness: action.payload.message
            }
        case 'PROVIDER_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                businesses: state.businesses.map(business => business._id === action.payload.business._id ? action.payload.business : business),
                resultbusiness: action.payload.message
            }
        case 'DOCUMENT_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                businesses: state.businesses.map(business => business._id === action.payload.business._id ? action.payload.business : business),
                resultbusiness: action.payload.message
            }
        case 'DOCUMENT_DELETE_SUCCESS':
            return {
                ...state,
                loading:false,
                businesses: state.businesses.map(business => business._id === action.payload.business._id ? action.payload.business : business),
                resultbusiness: action.payload.message
            }
        case 'PROVIDER_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading:false,
                business: action.payload.business,
                businesses: state.businesses.map(business => business._id === action.payload.business._id ? action.payload.business : business),
                resultbusiness: action.payload.message
            }
        case 'PROVIDER_RESET_RESULT':
            return {...state,
                resultbusiness: null
            }
        case 'PROVIDER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PROVIDER_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

